<div class="mainDiv">
  <div class="row">
    <div
      class="mainTxt d-flex justify-content-center align-items-center mt-3"
      style="color: #f5a63f; font-size: 60px; font-weight: 500; height: 60vh"
    >
      Coming Soon
    </div>
    <div class="search_Div mt-4 d-flex justify-content-center mb-4">
      <!-- <div class="search-container">
        <input type="text" placeholder="Search" [(ngModel)]="searchText" (keyup)="getSavednewsletterList(searchText)" />
        <span class="search-icon">🔍</span>
      </div> -->
    </div>
  </div>
</div>
